import { SignupEmailStep } from "@/components/auth/SignupEmailStep";
import { usePageTitle } from "../hooks/usePageTitle";

export function SignupEmailPage() {
  usePageTitle("Sign up | TidyRota");

  return <SignupEmailStep />;
}
